














import Vue, { PropType } from 'vue';
import { CourseraCourseDetail } from '~/models/coursera';

export default Vue.extend({
    name: 'CourseDetail',
    props: {
        detail: {
            type: Object as PropType<CourseraCourseDetail>,
            required: true,
        },
    },
    computed: {
        icon(): string {
            switch (this.detail.type) {
                case 'deadlines':
                    return 'calendar-alt';
                case 'certificate':
                    return 'stamp';
                case 'online':
                    return 'wifi';
                case 'level':
                    return 'signal';
                case 'duration':
                    return 'clock';
                case 'language':
                    return 'globe';
                default:
                    return '';
            }
        },
    },
});
